import React from "react";
import styled from "styled-components";
import { InnerLayout } from "../styles/Layouts";
import SectionTitle from "./SectionTitle";
import { motion } from "framer-motion";
import { useInView } from "./AnimatedComponents";

const skills = [
  "TypeScript",
  "React",
  "Python",
  "C# / .NET",
  "JavaScript",
  "Angular",
  "Node.js",
  "Terraform / HCL",
  "Azure",
  "Azure CLI",
  "Azure DevOps",
  "REST APIs",
  "SQL / NoSQL / CosmosDB",
  "Docker / Kubernetes",
  "Git",
  "Redux / Zustand / MobX",
  "Next.js",
  "Fluent UI",
  "Jest / React Testing Library",
  "Go",
  "PowerShell",
  "PyTorch / Deep Learning",
  "C / C++",
  "WebGL / DirectX",
  "WPF / 3D Rendering",
  "CI/CD / GitHub Actions",
];

const Skills: React.FC = () => {
  const { ref, inView } = useInView(0.1);

  return (
    <SkillsStyled>
      <SectionTitle title={"My Skills"} span={"skills"} />
      <InnerLayout>
        <div className="skills-grid" ref={ref}>
          {skills.map((skill, index) => (
            <motion.div
              key={skill}
              className="skill-chip"
              initial={{ opacity: 0, y: 20, scale: 0.9 }}
              animate={
                inView
                  ? { opacity: 1, y: 0, scale: 1 }
                  : { opacity: 0, y: 20, scale: 0.9 }
              }
              transition={{
                duration: 0.4,
                delay: index * 0.05,
                ease: [0.25, 0.1, 0.25, 1],
              }}
              whileHover={{
                y: -4,
                scale: 1.05,
                transition: { duration: 0.2 },
              }}
            >
              {skill}
            </motion.div>
          ))}
        </div>
      </InnerLayout>
    </SkillsStyled>
  );
};

const SkillsStyled = styled.section`
  .skills-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
  }

  .skill-chip {
    padding: 0.6rem 1.25rem;
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    border-radius: 100px;
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--white-color);
    cursor: default;
    transition:
      border-color 0.25s ease,
      box-shadow 0.25s ease,
      background 0.25s ease;

    &:hover {
      border-color: var(--primary-color);
      background: var(--background-light-color-2);
      box-shadow: 0 4px 15px rgba(99, 102, 241, 0.15);
    }
  }
`;

export default Skills;
